export default __webpack_public_path__ + "static/media/Rimail-logo 1.a770a746.svg";